module.exports = __webpack_public_path__ + "90f1d2f79e48be9e2aa9afc0dfc5e1fe.pdf";